import * as yup from 'yup';
export const validationSchema = yup.object().shape({
    Name: yup.string().required('Обязательное поле'),
    BirthDate: yup
        .string()
        .required('Обязательное поле')
        .matches(
            /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(19[0-9][0-9]|20[0-2][0-9])$/,
            'Неверная дата'
        )
        .test(
            'is-valid-date',
            'Некорректная дата',
            (value) => {
                const [day, month, year] = value.split('.').map(Number);
                const date = new Date(year, month - 1, day);
                const minDate = new Date(1915, 0, 1);
                return (
                    date.getFullYear() === year &&
                    date.getMonth() === month - 1 &&
                    date.getDate() === day &&
                    date >= minDate
                );
            }
        ),
    Email: yup
        .string()
        .required('Обязательное поле')
        .email('Некорректный формат почты'),
    Phone: yup
        .string()
        .required('Обязательное поле'),
    Theme: yup.string(),
    Description: yup.string()
});